/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Route_Not_FoundInputs */

const th_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบหน้านี้`)
};

const en_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That page does not exist.`)
};

const ja_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`そのページは存在しません。`)
};

const zh_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该页面不存在。`)
};

const es_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esa página no existe.`)
};

const pt_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa página não existe.`)
};

const id_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman itu tidak ada.`)
};

const fr_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette page n’existe pas.`)
};

const tl_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala ang pahinang iyon.`)
};

const vi_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có trang đó.`)
};

const ko_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그런 페이지는 없습니다.`)
};

const de_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Seite gibt es nicht.`)
};

const ru_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Такой страницы нет.`)
};

const tr_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Böyle bir sayfa yok.`)
};

const it_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quella pagina non esiste.`)
};

const pl_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taka strona nie istnieje.`)
};

const uk_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Такої сторінки немає.`)
};

const hi_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वह पृष्ठ मौजूद नहीं है।`)
};

const ar_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تلك الصفحة غير موجودة.`)
};

const ms_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman itu tidak wujud.`)
};

const bn_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওই পৃষ্ঠা নেই।`)
};

const zh_tw2_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該頁面不存在。`)
};

const zh_hk2_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該頁面不存在。`)
};

const ur_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وہ صفحہ موجود نہیں۔`)
};

const fa_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`چنین صفحه‌ای وجود ندارد.`)
};

const sw_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukurasa huo haupo.`)
};

const nl_route_not_found = /** @type {(inputs: Route_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die pagina bestaat niet.`)
};

/**
* | output |
* | --- |
* | "That page does not exist." |
*
* @param {Route_Not_FoundInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const route_not_found = /** @type {((inputs?: Route_Not_FoundInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Route_Not_FoundInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_route_not_found(inputs)
	if (locale === "ja") return ja_route_not_found(inputs)
	if (locale === "zh") return zh_route_not_found(inputs)
	if (locale === "es") return es_route_not_found(inputs)
	if (locale === "pt") return pt_route_not_found(inputs)
	if (locale === "id") return id_route_not_found(inputs)
	if (locale === "fr") return fr_route_not_found(inputs)
	if (locale === "tl") return tl_route_not_found(inputs)
	if (locale === "vi") return vi_route_not_found(inputs)
	if (locale === "ko") return ko_route_not_found(inputs)
	if (locale === "de") return de_route_not_found(inputs)
	if (locale === "ru") return ru_route_not_found(inputs)
	if (locale === "tr") return tr_route_not_found(inputs)
	if (locale === "it") return it_route_not_found(inputs)
	if (locale === "pl") return pl_route_not_found(inputs)
	if (locale === "uk") return uk_route_not_found(inputs)
	if (locale === "hi") return hi_route_not_found(inputs)
	if (locale === "ar") return ar_route_not_found(inputs)
	if (locale === "ms") return ms_route_not_found(inputs)
	if (locale === "bn") return bn_route_not_found(inputs)
	if (locale === "zh-TW") return zh_tw2_route_not_found(inputs)
	if (locale === "zh-HK") return zh_hk2_route_not_found(inputs)
	if (locale === "ur") return ur_route_not_found(inputs)
	if (locale === "fa") return fa_route_not_found(inputs)
	if (locale === "sw") return sw_route_not_found(inputs)
	if (locale === "nl") return nl_route_not_found(inputs)
	return en_route_not_found(inputs)
});